import React from 'react';
import { Check, X } from 'lucide-react';
import { getPasswordRuleStatus } from '../../lib/passwordPolicy';

// Indicateur de force du mot de passe en temps réel (USR-005).
// Affiche une barre de progression + la liste des règles avec coche/croix.
export default function PasswordStrengthMeter({ password }) {
  const rules = getPasswordRuleStatus(password || '');
  const metCount = rules.filter((r) => r.ok).length;
  const percent = (metCount / rules.length) * 100;

  let barColor = 'bg-red-500';
  if (metCount === rules.length) barColor = 'bg-emerald-500';
  else if (metCount >= rules.length - 1) barColor = 'bg-amber-500';
  else if (metCount >= rules.length / 2) barColor = 'bg-orange-500';

  if (!password) return null;

  return (
    <div className="mt-1.5 space-y-1.5">
      <div className="h-1.5 w-full rounded-full bg-gray-200 overflow-hidden">
        <div
          className={`h-full rounded-full transition-all duration-300 ${barColor}`}
          style={{ width: `${percent}%` }}
        />
      </div>
      <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-3 gap-y-1">
        {rules.map((rule) => (
          <li
            key={rule.key}
            className={`flex items-center gap-1.5 text-xs ${rule.ok ? 'text-emerald-600' : 'text-gray-400'}`}
          >
            {rule.ok ? <Check className="w-3.5 h-3.5 flex-shrink-0" /> : <X className="w-3.5 h-3.5 flex-shrink-0" />}
            <span>{rule.label}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
